class AppConvertService {

  appConvert (value)  {
    return value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^A-Z0-9]+/ig, "_")
      .toLowerCase()
  }

  toShort(address) {
    if (address){
      let prefix = address.substring(0, 6)
      let suffix = address.substring(address.length - 4, address.length)
      return prefix + "..." + suffix;
    }
    return "-"
  }

  /**
   * Helper to convert a string to Camel Case format
   * @param {string} input - The input string to convert
   * @returns {string} The camelCase formatted string
   */
  toCamelCase(input)  {
    // If input is null or undefined, return empty string
    if (!input) return '';

    // Split the string by underscore and convert to lowercase
    const words = input.toLowerCase().split('_');

    // Take first word as is, then capitalize first letter of remaining words
    return words[0] + words.slice(1)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join('');
  }

  /**
   * Capitalizes the first letter of a string and makes the rest lowercase
   * @param {string} input - The input string to convert
   * @returns {string} The formatted string
   */
  capitalize(input) {
    // Return empty string if input is null or undefined
    if (!input) return '';

    // Convert to string in case input is a number or other type
    const str = String(input);

    // Make first letter uppercase and rest lowercase
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }


  toAnonymous(code, value) {
    let prefix ='', suffix = ''
    switch (code){
      case 'EMAIL' :
         prefix = value.split('@')[0].substring(0, 2)
        suffix = '@'+value.split('@')[1]
        break
      case 'PHONE' :
         prefix = value.substring(0, 4)
         suffix = value.substring(value.length - 2, value.length)
        break
    }

    return prefix + "..." + suffix;
  }

  toFixed(number, decimals) {
    let x = Math.pow(10, Number(decimals) + 1)
    return (Number(number) + (1 / x)).toFixed(decimals)
  }
}

export default new AppConvertService()
